module.exports = "/_next/static/images/5f4cf822e1f1cc9d6acda5fee756b1cb-roxinho-details-metalico-md@3x.jpg";